const getRiskData = () => {
    var riskData = {};
    var risk_jd;
    try {
        risk_jd = getJdEid()
    } catch (e) {}
    try {
        //你的逻辑
        riskData.eid = risk_jd.eid
        riskData.fp = risk_jd.fp
        riskData.token = risk_jd.token
        // console.log(riskData)
    } catch (e) {
        //出现异常
    }
    return riskData
}
const shareWx = (shareDate,shareDataNew,shareSuccess) => {

    defer.then(function(res) {
        this.jsToGetResp(function(d) {
            if (typeof d != 'object') {
                d = $.parseJSON(d);
            }
            if (d.share) {
                if (parseInt(d.share.shareState) === 2) {
                    //分享成功回调
                    shareSuccess ? shareSuccess() : ''
                }
            }
        }, {
            type: 4,
            shareDate: shareDate,
            shareDataNew: shareDataNew
        })
    })
}

export {
    getRiskData,
    shareWx
}



// WEBPACK FOOTER //
// ./src/public/getRiskData.js